import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { useWS } from '../context/WSContext';
import { useTwin } from '../context/TwinContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { user, logout } = useAuth();
  const { theme, toggle } = useTheme();
  const { connected } = useWS();
  const { isDemo, getActiveTwin } = useTwin();
  const activeTwin = getActiveTwin();

  const links = [
    { path: '/app',           label: '📊 Dashboard'  },
    { path: '/app/scene',     label: '🎬 Scene'      },
    { path: '/app/entities',  label: '🏭 Entities'   },
    { path: '/app/ml',        label: '🤖 ML Insights' },
    { path: '/app/alerts',    label: '🔔 Alerts'     },
    { path: '/app/reports',   label: '📋 Reports'    },
    { path: '/app/twins',     label: '🔀 My Twins'   },
  ];

  const twinName = activeTwin?.name || activeTwin?.company || 'TwinMaker';
  const factoryEmoji = activeTwin?.factoryType === 'pharma' ? '🔬' : 
                       activeTwin?.factoryType === 'fmcg' ? '🥤' : 
                       activeTwin?.factoryType === 'custom' ? '🏭' : 
                       activeTwin?.factoryType === 'cookie' ? '🍪' : '🔌';

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <div className="logo" onClick={() => navigate('/')}>🏭 TwinMaker<span>SaaS</span></div>
        
        {activeTwin && (
          <div className="navbar-active-twin">
            <span className="twin-icon">{factoryEmoji}</span>
            <div className="twin-info">
              <div className="twin-name">{twinName}</div>
              <div className="twin-badge" style={{ color: isDemo ? '#a78bfa' : '#10b981' }}>
                {isDemo ? '📌 Demo' : '✨ Your Twin'}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="nav-links">
        {links.map(l => (
          <button key={l.path}
            className={`nav-btn ${location.pathname === l.path ? 'active' : ''}`}
            onClick={() => navigate(l.path)}>
            {l.label}
          </button>
        ))}
      </div>

      <div className="navbar-right">
        <div className="nav-status">
          {isDemo && (
            <span className="demo-badge">🎮 DEMO</span>
          )}
          <span className={`ws-badge ${connected ? 'connected' : ''}`}>
            {connected ? '⚡ Live' : '○ Sim'}
          </span>
        </div>

        <div className="nav-actions">
          {!isDemo && (
            <button 
              className="twin-switcher-btn"
              onClick={() => navigate('/app/twins')}
              title="Switch twin">
              🔄 Switch Twin
            </button>
          )}
          <button className="nav-icon-btn" onClick={toggle} title="Toggle theme">
            {theme === 'dark' ? '☀️' : '🌙'}
          </button>
          {user && (
            <div className="user-menu">
              <span className="user-badge" title={user.email}>
                {user.role === 'admin' ? '👤' : '👥'}
              </span>
              <div className="user-dropdown">
                <div className="user-info">
                  <div className="user-email">{user.email}</div>
                  <div className="user-role">{user.role}</div>
                </div>
                {user.email === 'anbunathan.r@gmail.com' && (
                  <button className="btn-signout" style={{ color: '#fbbf24' }} onClick={() => navigate('/app/admin')}>
                    👑 Admin Panel
                  </button>
                )}
                <button className="btn-signout" onClick={() => { logout(); navigate('/login'); }}>
                  🚪 Sign Out
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
